import {
  useFloating,
  autoUpdate,
} from '@floating-ui/react';
import { useCallback } from 'react';
import { useOnClickOutside } from 'usehooks-ts';
import { useDropDownContext } from '../../ui/drop-down';
import { useDialogContext } from '../dialog';
import { useDropDownMiddlewares } from './use-drop-down-middlewares';
import { IUseDropDownOptions } from './use-drop-down.types';

export const useDropDown = ({
  isOverToggler,
  middlewares,
  offset = 0,
  shouldAutoPlacement,
  shouldFlip,
  shouldShift = true,
  useParentWidth = true,
  placement = 'bottom',
  strategy,
  componentRef,
  shiftPadding,
}: IUseDropDownOptions) => {
  const { closeDropdown: closeDrop, isOpen, openDropdown: openDrop, toggleContent: toggleDrop } = useDropDownContext()

  const middleware = useDropDownMiddlewares({
    isOverToggler,
    middlewares,
    offset,
    shiftPadding,
    shouldAutoPlacement,
    shouldFlip,
    shouldShift,
    useParentWidth
  });

  const { isOpen: isDialogOpen } = useDialogContext();

  const clickOutsideHandler = useCallback(() => {
    // TODO: Fix clickOutside behaviour if there is a dialog opened
    if (!isDialogOpen) {
      closeDrop();
    }
  }, [closeDrop, isDialogOpen]);

  useOnClickOutside(componentRef, clickOutsideHandler);

  const { refs, floatingStyles } = useFloating({
    whileElementsMounted: autoUpdate,
    placement,
    middleware,
    strategy,
    open: isOpen,
  });

  return {
    openDrop,
    closeDrop,
    toggleDrop,
    isOpen,
    refs,
    floatingStyles,
  };
};
